type latLng = "lat" | "lon" | "lng"
type latLngStr = "latStr" | "lonStr" | "lngStr";
type area = "area";
type vazao = "vazao" | "vazaoEspecifica"
type metric = "metric" | "metros";
type tempos = "segundos" | "horas" | "minutos";
type data = "dia" | "mes" | "horaData" | "minutoData" | "segundoData";
type fileSize = "fileSize";
type percentage = "percent" | "percentage" | "porcentagem";

export type significantType = area | vazao | latLng | latLngStr | metric | tempos | fileSize | data | percentage;

Number.prototype.toSignificantDigits = function (dataType: significantType) {
  if ((this !== 0 && !this) || isNaN(this as number)) return "NaN";

  let strVal = this.toFixed(24);
  if (dataType === "percent" || dataType === "percentage" || dataType === "porcentagem") strVal = (Number(this) * 100).toFixed(24);

  const digitsBeforeDot = strVal.split(".")[0];
  const digitsAfterDot = strVal.split(".")[1];
  const nDigits = digitsBeforeDot.split(".")[0].length;
  let addEnd = "";

  let nDigitsAfterDot = 0;
  if (dataType === "area" && nDigits <= 1) nDigitsAfterDot = 1;
  else if (dataType === "lat" || dataType === "lon" || dataType === "lng") nDigitsAfterDot = 6;
  else if (dataType === "vazao" && nDigits <= 3) nDigitsAfterDot = 3 - nDigits;
  else if (dataType === "vazaoEspecifica" && nDigits <= 3) nDigitsAfterDot = 3 - nDigits;
  else if (dataType === "latStr" || dataType === "lonStr" || dataType === "lngStr") return latLngToStr(digitsBeforeDot, digitsAfterDot);
  else if (dataType === "metric" || dataType === "metros") nDigitsAfterDot = 2;
  else if (dataType === "minutos" || dataType == "segundos" || dataType === "horas") nDigitsAfterDot = 0;
  else if (dataType === "percent" || dataType === "percentage" || dataType === "porcentagem") {
    nDigitsAfterDot = 2;
    addEnd = "%";
  }
  else if (dataType === "fileSize") return formatBytes(digitsBeforeDot);
  else if (dataType === "dia" || dataType === "mes" || dataType === "horaData" || dataType === "minutoData" || dataType === "segundoData") return digitsBeforeDot.rjust(2, "0");

  const strFormatted = digitsBeforeDot + ((nDigitsAfterDot > 0) ? "," : "") + digitsAfterDot.slice(0, nDigitsAfterDot);
  return strFormatted + addEnd;
};

const latLngToStr = (beforeDot: string, afterDot: string): string => {
  const graus = beforeDot;
  const mins = (Number("0." + afterDot) * 60).toString().split(".")[0];
  const secs = ((Number("0." + afterDot) - Number(mins) / 60) * 3600).toFixed(0);

  return graus + "° " + mins + "' " + secs + '"';
};

function formatBytes(beforeDot: string): string {
  const bytes = Number(beforeDot);

  if (bytes === 0) return '0 Bytes';

  const base = 1000;
  const unidades = [' Bytes', 'KB', 'MB', 'GB', 'TB', 'PB'];

  const expoente = Math.floor(Math.log(bytes) / Math.log(base));
  const valor = parseFloat((bytes / Math.pow(base, expoente)).toFixed(2));

  return `${valor}${unidades[expoente]}`;
}